import React, { useEffect, useRef, useState } from "react";
import { BsBellFill } from "react-icons/bs";

import "./CandidateNotificationTopBell.css";
import {
  fetchNotifications,
  fetchUnreadCount,
  markAllNotificationsAsRead,
  deleteNotificationById,
  deleteAllReadNotifications,
} from "../../../../services/candidate/api";
import ConfirmModal from "../../../../utils/confirmmodal/ConfirmModal";
import { toast } from "react-toastify";

const CandidateNotificationTopBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [loadingNotifications, setLoadingNotifications] = useState(false);
  const notificationRef = useRef(null);

  const [confirmModal, setConfirmModal] = useState({
    open: false,
    title: "",
    message: "",
    action: null,
  });

  useEffect(() => {
    // Load immediately
    loadUnreadCount();
  }, []);

  const loadNotifications = async () => {
    setLoadingNotifications(true);

    try {
      const data = await fetchNotifications();
      setNotifications(data || []);
    } catch (err) {
      setNotifications([]);
    } finally {
      setLoadingNotifications(false);
    }
  };

  const loadUnreadCount = async () => {
    try {
      const count = await fetchUnreadCount();
      setUnreadCount(count || 0);
    } catch (err) {}
  };

  const handleBellClick = async () => {
    if (!open) {
      setOpen(true); // Open immediately

      loadNotifications(); // Don't await so loading spinner is shown

      try {
        await markAllNotificationsAsRead();
        setUnreadCount(0);
      } catch (err) {}
    } else {
      setOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // add notification event listener .
  useEffect(() => {
    const handleNewNotification = (event) => {
      const notification = event.detail;
      console.log(notification);
      setNotifications((prev) => [notification, ...prev]);

      setUnreadCount((prev) => prev + 1);
    };

    window.addEventListener("candidate-notification", handleNewNotification);

    return () =>
      window.removeEventListener(
        "candidate-notification",
        handleNewNotification,
      );
  }, []);

  // Delete single notification
  const confirmDeleteNotification = (current) => {
    setConfirmModal({
      open: true,
      title: "Delete Notification",
      message:
        "Are you sure you want to delete this notification?\n" +
        current.message,
      action: async () => {
        try {
          await deleteNotificationById(current.id);

          setNotifications((prev) =>
            prev.filter((item) => item.id !== current.id),
          );

          toast.success("Notification Deleted Successfully");
        } catch (error) {
          toast.error(
            error.response?.data?.message || "Failed to delete notification.",
          );
        } finally {
          setConfirmModal((prev) => ({
            ...prev,
            open: false,
          }));
        }
      },
    });
  };

  const formatNotificationDate = (item) => {
  const timestamp = item.createdAt || item.notificationTime;

  if (!timestamp) {
    return "Date unavailable";
  }

  const parsedDate = new Date(timestamp);

  if (isNaN(parsedDate.getTime())) {
    return "Invalid date";
  }

  return parsedDate.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
  // Delete all read notifications
  const confirmDeleteAll = () => {
    setConfirmModal({
      open: true,
      title: "Delete Read Notifications",
      message: "Are you sure you want to delete all read notifications?",
      action: async () => {
        try {
          await deleteAllReadNotifications();

          await loadNotifications();
          await loadUnreadCount();

          toast.success("All Notifications are Deleted Successfully");
        } catch (error) {
          toast.error(
            error.response?.data?.message || "Failed to delete notifications.",
          );
        } finally {
          setConfirmModal((prev) => ({
            ...prev,
            open: false,
          }));
        }
      },
    });
  };

  return (
    <div className="notification-container" ref={notificationRef}>
      <div className="notification-bell" onClick={handleBellClick}>
        <BsBellFill />

        {unreadCount > 0 && (
          <span className="notification-count">{unreadCount}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <span>Notifications</span>

            {notifications.length > 0 && (
              <button className="delete-all-btn" onClick={confirmDeleteAll}>
                Delete Read
              </button>
            )}
          </div>

          <div className="notification-list">
            {loadingNotifications ? (
              <div className="notification-loading">
                <div className="notification-spinner"></div>
                <p>Loading notifications...</p>
              </div>
            ) : notifications.length === 0 ? (
              <div className="notification-empty">
                No notifications available
              </div>
            ) : (
              
              notifications.map((item, index) => {
 
  return (
    <div className="notification-item" key={index}>
      <p>{item.message}</p>

   
<span>{formatNotificationDate(item)}</span>
      <button
        className="delete-btn"
        onClick={() => confirmDeleteNotification(item)}
      >
        ✖
      </button>
    </div>
  );
})
            )}
          </div>
        </div>
      )}

      <ConfirmModal
        isOpen={confirmModal.open}
        title={confirmModal.title}
        message={confirmModal.message}
        confirmText="Delete"
        cancelText="Cancel"
        danger
        onCancel={() =>
          setConfirmModal((prev) => ({
            ...prev,
            open: false,
          }))
        }
        onConfirm={confirmModal.action}
      />
    </div>
  );
};

export default CandidateNotificationTopBell;
